/**
 * @typedef {'number' | 'percent' | 'text' | 'phone' | 'date' | 'datetime' | 'boolean' | 'custom' | 'mapping' | 'priceRub'} Display
 */

/**
 * @typedef {object} Extractor
 * @property {string} title
 * @property {string} extractor
 * @property {Display} type
 * @property {string} [requestField]
 * @property {boolean} [edit]
 * @property {(v: object) => string} [mapper]
 * @property {() => Promise<Array<SelectOption>>} [fetchOptions]
 * @property {(v: string) => any} [cast]
 */

export const TYPE_TO_FORMATTER = {
  number: (number) => Number(number),
  percent: (v) => `${Number(v * 100)}%`,
  text: (v) => v,
  mapping: (v) => v,
  /**
   * @param {string} phoneNumber
   */
  phone: (phoneNumber) =>
    `${phoneNumber.slice(0, 2)} (${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(5, 8)} ${phoneNumber.slice(8, 10)}-${phoneNumber.slice(10, 12)}`,
  date: (v) => new Date(v).toLocaleDateString(),
  datetime: (v) => {
    const date = new Date(v);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  },
  boolean: (v) => (v ? "Да" : "Нет"), // TODO: i18n
  /**
   * @param {number} price
   */
  priceRub: (price) =>
    price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " ₽",
};

/**
 * @template T
 * @param {T} obj
 * @param {Display} type
 * @param {(v: T) => string} [mapper]
 * @param {Array<Option>} [options]
 * @returns {string}
 */
export const formatObject = (obj, type, mapper, options) => {
  if (obj == null) {
    return "-";
  }
  if (type === "custom") {
    return mapper(obj);
  }
  const result = TYPE_TO_FORMATTER[type](obj);
  if (type === "mapping" && options != null) {
    return options.find((opt) => opt.value === result)?.name;
  }
  return result;
};

/**
 * @param {number} minutesBalance
 * @returns {{hours: number, minutes: number}}
 */
export const formatMinutesBalance = (minutesBalance) => {
  return {
    hours: Math.floor(minutesBalance / 60),
    minutes: minutesBalance % 60,
  };
};

/**
 * @param {object} row
 * @param {Extractor} extractor
 * @returns {any}
 */
export const getValueFromExtractor = (row, extractor) => {
  if (row == null) {
    return null;
  }

  let keys;
  try {
    keys = extractor.extractor.split(".");
  } catch {
    console.error("Failed to split extractor:", extractor);
    return null;
  }

  let value = row;
  for (let key of keys) {
    if (key in value) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      value = value[key];
    } else if (extractor.default != null) {
      value = extractor.default;
    } else {
      value = undefined;
    }
  }

  if (value === row) {
    console.error(
      "Wrong extractor. value:",
      value,
      "row:",
      row,
      "extractor:",
      extractor,
    );
    throw "Wrong extractor";
  }

  return value;
};
